import React, {memo} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Season} from '@chekin/core';
import {ResponsiveSheet} from '@chekinapp/ui';
import {ListExemption, ExemptionText} from './styled';

type ExemptionsListModalProps = {
  isOpen: boolean;
  close: () => void;
  exemptions?: Season['exemptions'];
};
const ExemptionsListModal = memo(
  ({isOpen, close, exemptions}: ExemptionsListModalProps) => {
    const {t} = useTranslation();

    return (
      <ResponsiveSheet
        open={isOpen}
        onClose={close}
        title={t('exemptions_list')}
        closeOnOverlayClick
        contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
        className="w-auto"
      >
        <ExemptionText className="mt-3">
          <Trans i18nKey="exemptions_list_text">
            This city may exempt certain categories of travelers from paying tourist
            taxes. Please note that exemptions needs to be <b>verified</b> upon arrival.
          </Trans>
        </ExemptionText>
        <ListExemption>
          <ul>
            {exemptions?.map(exemption => {
              return <li key={exemption.id}>{exemption.exemption_name}</li>;
            })}
          </ul>
        </ListExemption>
      </ResponsiveSheet>
    );
  },
);

export {ExemptionsListModal};
